import { useTranslation } from "react-i18next";

import { ModalFooter } from "shared/components/Modals/Modal";

import { simplyClick } from "shared/helpers/analytics";

import styles from "@platformAssets/components/DeactivateModal.module.scss";
import stylesModal from "@platformAssets/components/Modal.module.scss";

import { ReactComponent as CheckIcon } from "assets/shared/img/icons/check-circle.svg";
import { ReactComponent as CircleIcon } from "assets/shared/img/icons/cross-circle.svg";

const DeactivateStepOne = ({ handleCloseClick, setStep, username }) => {
  const { t } = useTranslation("settings");

  /**
   * Handle continue click event
   * @param {Object} event Click event object
   */
  const handleContinueClick = (event) => {
    event?.preventDefault();

    setStep(1);
  };

  return (
    <>
      <p className={styles.deactivateTitle}>
        {t("deactivateModalStepOneTitle", {
          username,
        })}
      </p>

      <div className={styles.textDanger}>
        <p>
          <CircleIcon />
          {t("deactivateTextOne", {
            brandName: import.meta.env.VITE_APP_MULTI_SITE_BRAND_NAME,
          })}
        </p>
        <p>
          <CircleIcon />
          {t("deactivateTextTwo")}
        </p>
        <p>
          <CircleIcon />
          {t("deactivateTextThree", {
            brandName: import.meta.env.VITE_APP_MULTI_SITE_BRAND_NAME,
          })}
        </p>
        <p>
          <CheckIcon />
          {t("deactivateTextFour", {
            username,
          })}
        </p>
      </div>

      <ModalFooter customClass={stylesModal.DeactivateFooter}>
        <button
          onClick={handleContinueClick}
          className={stylesModal.primaryButtonDeactivate}
        >
          {t("deactivateModalDeleteAnyway")}
        </button>
        <button
          onClick={(event) => {
            handleCloseClick(event);
            simplyClick(window.simplyEvent.cl_deactiv_prof_cancel);
          }}
          className={stylesModal.defaultButton}
        >
          {t("cancelButton")}
        </button>
      </ModalFooter>
    </>
  );
};

export { DeactivateStepOne };
